import * as React from "react";

import { Video, Move } from "../../types";
import { Space } from "../../styled-component";
import useFetchMove from "../../hooks/moves/useFetchMove";

import VideoComponents from "../video";
import Layout from "../common/Layout";
import Text from "../common/Text";

export interface MoveOneProps {
  move?: Move;
  moveId?: Move["id"];
}

function MoveOne({ move: moveProp, moveId }: MoveOneProps) {
  const { data } = useFetchMove(moveId, { enabled: !!moveId });
  const move = data || moveProp;
  const { name, videos } = move || {};

  return (
    <Layout.Column alignItems="center">
      <VideoComponents.Carousel videos={videos} />

      <Space />

      {name && <Text.SubHeader numberOfLines={1}>{name}</Text.SubHeader>}
    </Layout.Column>
  );
}

export default MoveOne;
